import React, { ComponentProps, ComponentType } from 'react'

import styled from '@emotion/styled'

import type { Colors, Spacings } from '@surglogs-app/ui.theme'

import { FlexBox } from './FlexBox'

const StyledBox = styled(FlexBox, {
  shouldForwardProp: (prop) =>
    !['color', 'size', 'rounded', 'iconColor'].includes(prop),
})<{ variant: Colors; iconColor: Colors; size: Spacings; rounded: boolean }>`
  --size: ${({ theme, size }) => theme.ui.spacings[size]};
  --min-icon: ${({ theme }) => theme.ui.spacings.lg};

  align-items: center;
  justify-content: center;
  width: var(--size);
  height: var(--size);
  background-color: ${({ theme, variant }) => theme.ui.colors[variant]};
  border-radius: ${({ theme, rounded, bra = 'sm' }) =>
    rounded ? '50%' : theme.ui.spacings[bra]};

  svg {
    width: max(var(--min-icon), calc(var(--size) / 2));
    color: ${({ theme, iconColor }) => theme.ui.colors[iconColor]};
  }
`

interface BoxIconProps
  extends Omit<
    ComponentProps<typeof StyledBox>,
    'size' | 'color' | 'rounded' | 'iconColor'
  > {
  variant: Colors
  size: Spacings
  icon: ComponentType<any>
  rounded?: boolean
  iconColor?: Colors
}

export const BoxIcon = ({
  variant,
  size,
  icon: Icon,
  rounded = false,
  bra = 'sm',
  iconColor = 'white.100',
  ...rest
}: BoxIconProps) => {
  return (
    <StyledBox {...{ variant, size, rounded, bra, iconColor, ...rest }}>
      <Icon />
    </StyledBox>
  )
}
